import { render } from "./LinkedContactsTab.vue?vue&type=template&id=d1393fce&scoped=true"
import script from "./LinkedContactsTab.vue?vue&type=script&lang=js"
export * from "./LinkedContactsTab.vue?vue&type=script&lang=js"

import "./LinkedContactsTab.vue?vue&type=style&index=0&id=d1393fce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1393fce"]])

export default __exports__